export class MacroData {
    date;
    calories;
    protein;
    carbohydrates;
    fats;
    constructor(date = undefined, calories = 0, protein = 0, carbohydrates = 0, fats = 0) {
        this.date = date;
        this.calories = calories;
        this.protein = protein;
        this.carbohydrates = carbohydrates;
        this.fats = fats;
    }
}
//# sourceMappingURL=macroData.js.map